module.exports = __webpack_public_path__ + "static/media/dublin-international-film-festival.561d7fab.jpg";